export * from "./new-inventory-release.component";
